
// 基本的页面地址
import {UrlConfig} from "../../config/url-config.ts";

// 用户数据初始化
export const INIT_USER_URL = `${UrlConfig.BASE_API_URL}initinfo`;
// 获取rank列表
export const RANK_LIST_URL = `${UrlConfig.BASE_API_URL}getrank`;
// 获得每日游戏的单词
export const DAILY_WORD_URL = `${UrlConfig.BASE_API_URL}getword1`;
// 获取闯关的所有单词
export const CHALLENGE_WORD_URL = `${UrlConfig.BASE_API_URL}getword2`;
// 游戏结束后调用接口发送游戏数据给后端
export const PLAY_END = `${UrlConfig.BASE_API_URL}playend`;

// 退出登录
export const LOGOUT = "/sys/users/logout";
// 游客登录
export const LOGIN_BY_GUEST = "/sys/users/login/guest";
// CGTN登录
export const LOGIN_BY_CGTN = "/sys/users/login/cgtn";
// 更新CGTN头像
export const UPDATE_AVATAR = "/sys/users/update/avatar";
// 获取profile里的四种游戏状态数据
export const LOAD_GAME_DATA_PROFILE = "/sys/user-game-data/load/game/data";
// 获取用于选择的所有国家的列表
export const COUNTRY_LIST = "/sys/country/list";
// 修改用户的国家区域
export const UPDATE_USER_COUNTRY = "/sys/users/update/country";
// 获取所有徽章列表
export const MEDAL_LIST = "/sys/medal/list";
// 获取所有的头像框
export const AVATAR_FRAME_LIST = "/sys/avatar-frame/list";
// 获取已经装备的头像框
export const AVATAR_FRAME_EQUIPPED = "/sys/avatar-frame/user/equipped";
// 设置头像框装备状态
export const SET_AVATAR_FRAME_EQUIP_STATUS = "/sys/avatar-frame/set/equip/status";
// 获取主题列表
export const THEME_LIST = "/sys/theme/list";
// 获取已经装备的主题设置
export const THEME_EQUIPPED_SETTINGS = "/sys/theme-settings/get/equipped/settings";
// 设置主题皮肤装备状态
export const SET_THEME_EQUIP_STATUS = "/sys/theme/set/equip/status";
// 设置徽章装备状态
export const SET_MEDAL_EQUIP_STATUS = "/sys/medal/set/equip/status";
// 获取用户已经装备的徽章
export const LOAD_USER_EQUIPPED_LIST = "/sys/medal/equipped/list";

// 获取每日游戏的正确单词
export const DAILY_GAME_CORRECT_WORD = "/sys/word/get/daily/game/correct/word";
// 获取每日游戏状态
export const DAILY_GAME_PLAY_STATUS = "/sys/user-game-data/get/daily/game/play/status";
// 每日游戏结束后发起请求
export const DAILY_GAME_PLAY_OVER = "/sys/user-game-data/submit/daily/game/play/status";
// 获取每日游戏的nextTIme
export const DAILY_GAME_NEXT_TIME = "/sys/user-game-data/load/daily/nextTime";

// 获取AI对战的单词列表
export const AI_CHALLENGE_WORD_LIST = "/sys/word/get/ai-challenge/wordList";
// AI对战结束后提交游戏结果到后端
export const SUBMIT_AI_CHALLENGE_RESULT = "/sys/user-game-data/submit/ai/game/end";

// 获取每日游戏的排行榜数据
export const LOAD_DAILY_GAME_RANK = "/sys/daily-game-log/load/daily/rank";
// 获取AI对战的排行榜数据
export const LOAD_AI_GAME_RANK = "/sys/user-game-data/load/ai/rank";

// 创建vs-player房间
export const CREATE_VS_PLAYER_ROOM = "/sys/vs-player-room/generate/room/by/hard-level";
// 检测vs-player房间是否有被邀请者进来了
export const CHECK_VS_PLAYER_INVITED_ENTERED = "/sys/vs-player-room//check/room/entered";
// 获取vs-player房间列表
export const LOAD_VS_PLAYER_ROOM_LIST = "/sys/vs-player-room/list/all";
// 加入vs-player房间
export const JOIN_VS_PLAYER_ROOM = "/sys/vs-player-room/join/room";
// 提交 vs-player 房间游戏结果到后端
export const SUBMIT_VS_PLAYER_RESULT = "/sys/vs-player-room/submit/result";

// 创建UGC单词
export const CREATE_UGC_WORD = "/sys/ugc-word/create/word";
// 获取UGC单词列表
export const LOAD_UGC_WORD_LIST = "/sys/ugc-word/get/ugc/words";
// 获取UGC单词详情
export const LOAD_UGC_WORD_TO_PLAY = "/sys/ugc-word/get/word/to/play";
// 提交UGC游戏结果
export const SUBMIT_UGC_RESULT = "/sys/ugc-game-log/submit/ugc/game/result";
// 设置UGC单词点赞
export const SET_UGC_WORD_LIKE = "/sys/ugc-word/set/word/like";

// 登录获取各种奖励
export const LOGIN_GET_REWARD = "/sys/award/login/reward/list";
// 游戏胜利获取各种奖励
export const GAME_WIN_GET_REWARD = "/sys/award/game/win/reward/list";
// 分享获得徽章
export const SHARE_GET_REWARD = "/sys/award/share/reward/list";
// 根据用户id获取用户信息
export const GET_USER_INFO_BY_ID = "/sys/users/custom/user/info";



